import React, { Component } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';

import Dialog from '../../components/Dialog/Dialog';
import { ButtonPrimary, ButtonDefault } from "../../components/Button/Button";

import DocumentoViewer from '../../forms/Documento/DocumentoViewer';

export class DialogUploadMatricula extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            dialog: {
                open: false,
                file: null,
            },
            confirmado: false
        }
    }

    open = (file) => {
        this.setState({
            dialog: {
                open: true,
                file: file
            },
            confirmado: false
        });
    }

    close = (isCancel = true) => {
        if (isCancel && this.props.onCancel) {
            this.props.onCancel();
        }

        this.setState({
            dialog: {
                open: false,
                file: null
            },
            confirmado: false
        });
    }

    handleConfirm = () => {
        const { dialog } = this.state;

        if (this.props.onConfirm) {
            this.props.onConfirm(dialog.file);
        }

        this.close(false);
    }

    actions = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={this.state.confirmado}
                            onChange={(e) => this.setState({ confirmado: e.target.checked })}
                            color="primary"
                        />
                    }
                    label="Declaro que o documento está legível e é o arquivo correto."
                    style={{ paddingLeft: 15 }}
                />

                <div>
                    <ButtonDefault
                        onClick={() => this.close(true)}
                        startIcon={<ClearOutlinedIcon />}
                        style={{ margin: 4, backgroundColor: '#e84b3dce', color: 'white' }}
                        name="Cancelar"
                    />

                    <ButtonPrimary
                        onClick={this.handleConfirm}
                        startIcon={<CheckOutlinedIcon />}
                        style={{ margin: 4 }}
                        name="Confirmar"
                        disabled={!this.state.confirmado}
                    />
                </div>

            </div>
        )
    }

    render() {
        const { dialog } = this.state;
        const title = 'Visualização do Comprovante de Matrícula';

        return (
            <>
                <Dialog
                    openDialog={dialog.open}
                    title={title}
                    closeDialog={this.close}
                    actions={this.actions()}
                    fullWidth={true}
                    maxWidth={"lg"}
                >
                    <div style={{ height: '65vh', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                            <div style={{ height: '100%', overflow: 'hidden' }}>
                                <DocumentoViewer file={dialog.file} />
                            </div>
                        </div>
                    </div>
                </Dialog>
            </>
        );
    }
}

export default DialogUploadMatricula;